import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface DefensiveBehavioursSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Arguing or talking back",
  "Refusal to follow instructions",
  "Eye-rolling or sarcastic remarks",
  "Blaming others or making excuses",
  "Ignoring staff or pretending not to hear",
  "Deliberate stalling or dawdling",
  "Becoming bossy or controlling",
  "Excessive complaining or negative comments",
  "Continual shouting out/disruption",
  "Asking challenging questions",
  "Acting in a threatening manner",
  "Refusing to attempt learning tasks",
  'Over-compliance with passive aggression (e.g. "Whatever")',
  "Sudden withdrawal or shutting down",
  "Minor rule-breaking or pushing boundaries",
];

export const DefensiveBehavioursSection: React.FC<
  DefensiveBehavioursSectionProps
> = ({ values, otherValue, onCheckboxChange, onOtherChange, className }) => (
  <CollapsibleFormSection
    title="Select/describe the student's low-level challenging behaviours or defensive behaviours."
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label className="other-input-label" htmlFor="defensiveBehavioursOther">
        Other:
      </label>
      <input
        type="text"
        id="defensiveBehavioursOther"
        name="defensiveBehavioursOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
